import { CardContents, Shop } from "@/types/v2";
import { shop } from "@/repositories/shop";
import { showErrorToast, showSuccessToast } from "@/lib/toast";
import { captureException } from "@/services/sentry";

/**
 * Updates the card contents of a shop with the provided values.
 * @param {Shop} shopData - The shop object containing the current card configuration and contents.
 * @param {Partial<CardContents>} values - The partial card contents object with the values to update.
 * @returns {void} This function does not return anything but performs an asynchronous update operation.
 */
export function updateCardContents(
  shopData: Shop,
  values: Partial<CardContents>
) {
  const { id: shopId } = shopData;

  const newCardContents: Partial<Shop> = {
    cardConfig: {
      ...shopData.cardConfig,
      cardContents: { ...shopData.cardConfig.cardContents, ...values },
    },
  };
  shop
    .update(shopId, newCardContents)
    .then(() =>
      showSuccessToast(
        "Card Contents Updated",
        "The card contents have been updated. Return to the dashboard to view."
      )
    )
    /* eslint-disable @typescript-eslint/no-explicit-any */
    .catch((err: any) => {
      console.error("An error occurred updating statuses to fetch: ", err);
      captureException(err);
      showErrorToast(
        "Card Contents Failed to Update",
        `An error occurred updating card contents: ${err}`
      );
    });
}
